import Vue from 'vue'
import mutations from './mutations'
import clientsBusinessUnits from '@/api/clientsBusinessUnits'
import { arrayToObject } from '@/utils/object'
import { notify } from '@/utils/error'

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems ({ commit }, { childCompanyId }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.getAll({ childCompanyId })
          .then(response => {
            const items = arrayToObject(response.data.items)
            commit('setElements', { type: 'items', elements: items })
            resolve(items)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    loadItem ({ commit }, { childCompanyId, businessUnitId }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.getById({ childCompanyId, businessUnitId })
          .then(response => {
            const item = response.data.items[0]
            commit('setElement', { type: 'items', id: item.id, element: item })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    saveItem ({ commit }, { childCompanyId, item }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.save({ childCompanyId, item })
          .then(response => {
            const itemId = response.data.items[0].id
            commit('setElement', { type: 'items', id: itemId, element: { id: itemId, ...item } })
            resolve(item)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    deleteItem ({ commit, state }, { childCompanyId, businessUnitId }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.delete({ childCompanyId, businessUnitId })
          .then(response => {
            commit('removeElement', { type: 'items', id: businessUnitId })
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    updateRegistered ({ commit, state }, { childCompanyId, data }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.toggleRegistered({ childCompanyId, data })
          .then(response => {
            const registerDate = data.close ? null : data.validity_date
            commit('setRegistered', { businessUnitId: data.id, registerDate })
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },
    setHeader (context, { childCompanyId, businessUnitId, header }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.setHeader({ childCompanyId, businessUnitId, header })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getHeader (context, { childCompanyId, businessUnitId }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.getHeader({ childCompanyId, businessUnitId })
          .then(response => {
            const data = response.data.items[0].data
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    setFooter (context, { childCompanyId, businessUnitId, footer }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.setFooter({ childCompanyId, businessUnitId, footer })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getFooter (context, { childCompanyId, businessUnitId }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.getFooter({ childCompanyId, businessUnitId })
          .then(response => {
            const data = response.data.items[0].data
            resolve(data)
          })
          .catch(error => reject(error))
      })
    },
    sourceBusinessUnits (context, { childCompanyId }) {
      return new Promise((resolve, reject) => {
        clientsBusinessUnits.sourceBusinessUnits({ childCompanyId })
          .then(response => {
            const data = response.data.items
            resolve(data)
          })
          .catch(error => reject(error))
      })
    }
  },

  mutations: {
    ...mutations,
    setRegistered (state, { businessUnitId, registerDate }) {
      Vue.set(state.items[businessUnitId], 'register_date', registerDate)
    }
  }
}
